export enum Screen {
    EnlaceClienteEmpresa = '0DE0174D-E5B1-4439-8A08-9F8E89790AE9',
    Activacion = 'B168B8CE-A189-4E14-AD4A-713DBB1FD25A',
    AsignacionRolUsuario = 'AA22D20B-118E-48BF-BA9D-D16B252DDB15',
    ActivacionCuenta = '71E29C01-C11A-4644-942D-3BB380C0A7FF',
    InactivacionCuenta = '743DC9F9-FFA9-44BC-8889-5356D63F3DF4',
    CreacionUsuarioEmpleadoEikon = '46840278-9F4C-480F-ACAD-8A885C9A9E3B',
    Home ='E2A4FE3E-4CAD-45D8-AD89-35C93ABB7452',
    EjecutivoInterno ='B328C008-6F37-4E2E-A8FA-B57A89888A6D'
}